// Angular
import { Routes } from '@angular/router';
// Layouts
import { BaseLayoutComponent } from '@app/landing/layouts/base-layout';

export const routes: Routes = [
  { path: 'rehacare', loadChildren: () => import('@app/landing/features/rehacare-redirect/rehacare-redirect.routes').then(m => m.routes) },
  {
    path: '',
    component: BaseLayoutComponent,
    children: [
      { path: 'o-nas', loadChildren: () => import('./features/about/about.routes').then(m => m.routes) },
      { path: 'kontakt', loadChildren: () => import('./features/contact/contact.routes').then(m => m.routes) },
      { path: 'polityka-cookies', loadChildren: () => import('./features/cookie-policy/cookie-policy.routes').then(m => m.routes) },
      { path: 'szkolenia', loadChildren: () => import('@app/landing/features/course/course.routes').then(m => m.routes) },
      { path: 'projekty-eu', loadChildren: () => import('@app/landing/features/eu-project/eu-project.routes').then(m => m.routes) },
      { path: 'dofinansowania', loadChildren: () => import('@app/landing/features/funding/funding.routes').then(m => m.routes) },
      { path: 'polityka-prywatnosci', loadChildren: () => import('./features/privacy-policy/privacy-policy.routes').then(m => m.routes) },
      { path: 'serwis', loadChildren: () => import('./features/service/service.routes').then(m => m.routes) },
      { path: 'rozwiazania', loadChildren: () => import('./features/solution/solution.routes').then(m => m.routes) },
      { path: '', loadChildren: () => import('./features/home/home.routes').then(m => m.routes) },
      { path: '**', redirectTo: '/', pathMatch: 'full' }
    ]
  }
];
